import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { IFacebookBusinessApiPayload, IPagesApiPayload } from '@boxx/facebook-core';
//import { Facebook } from '@awesome-cordova-plugins/facebook/ngx';
import { Platform } from '@ionic/angular';
// import firebase from 'firebase/app';
//import { initializeApp } from 'firebase/app';

import 'firebase/auth';
import { BoxxOAuthTemplateMethod } from '../classes/OAuthTemplateMethod';
import {
  IFacebookOAuthResponse,
  IFacebookPluginOAuthResponse,
} from '../contracts/IFacebookOauthResponse';

@Injectable({
  providedIn: 'root', //<-- in order to be a singleton
})
export class BoxxFacebookOAuthService extends BoxxOAuthTemplateMethod {
  private baseUrl = 'https://graph.facebook.com';
  //private readonly provider = new firebase.auth.FacebookAuthProvider();

  constructor(
    private httpClient: HttpClient,
    //private fb: Facebook,
    //private fireAuth: AngularFireAuth,
    platform: Platform
  ) {
    super(platform);
  }

  getProvider() {
    //return this.provider;
  }

  async nativeOAuth(permissions: string[] = []): Promise<IFacebookOAuthResponse> {
    return null;
    // let userPages: any = null;
    // let hasRequestPages = false;
    // try {
    //   const authResponse = (await this.fb.login([
    //     'public_profile',
    //     'email',
    //     ...permissions,
    //   ])) as unknown as IFacebookPluginOAuthResponse;

    //   if(permissions.length > 0){
    //     permissions.forEach( (p) => {
    //       if(p === 'pages_show_list'){
    //         hasRequestPages = true;
    //       }
    //     });         
    //   }

    //   const { firstName, lastName } = (await this.fb.getCurrentProfile()) as {
    //     firstName: string;
    //     lastName: string;
    //     userID: string;
    //   };

    //   const { email } = (await this.fb.api(
    //     'me/?fields=email&access_token=' + authResponse.authResponse.accessToken,
    //     ['email']
    //   )) as { email: string; id: string };

    //   if(hasRequestPages){
    //     userPages = (await this.fb.api(
    //       '/me/accounts',
    //       null, null
    //     ));
    //   }

    //   const response: IFacebookOAuthResponse = {
    //     authResponse: authResponse.authResponse,
    //     status: authResponse.status,
    //     profileResponse: {
    //       firstName,
    //       lastName,
    //       email,
    //     },
    //     pages: userPages
    //   };

    //   return response;
    // } catch (e) {
    //   console.error('nativeOAuth()', e);
    //   this.manageOAuthError(e);
    //   return null;
    // }
  }

  async webOAuth(permissions: string[] = []): Promise<IFacebookOAuthResponse> {
    let hasRequestPages = false;
    let userPages: any = null;
    try { 
      return null;
      //  if(permissions.length > 0){
      //     permissions.forEach( (p) => {
      //       if(p === 'pages_show_list'){
      //         hasRequestPages = true;
      //       }
      //     this.provider.addScope(p);
      //   });         
      //  }
      // //this.provider.addScope('pages_manage_metadata');
      // const oauthResponse = await this.fireAuth.signInWithPopup(this.provider);
      // const respProfile = oauthResponse.additionalUserInfo.profile as any;
      
      // if(hasRequestPages){
      //   userPages = await this.getSelectedPagesList(respProfile.id, (oauthResponse.credential as any).accessToken)
      //   .toPromise();
      // }

      // const response: IFacebookOAuthResponse = {
      //   authResponse: {
      //     accessToken: (oauthResponse.credential as any).accessToken,
      //     data_access_expiration_time: '',
      //     expiresIn: '',
      //     userID: respProfile.id,
      //   },
      //   status: '',
      //   profileResponse: {
      //     firstName: respProfile.first_name,
      //     lastName: respProfile.last_name,
      //     email: respProfile.email,
      //   },
      //   pages: userPages
      // };

      // return response;
    } catch (e) {
      console.error('webOAuth()', e);
      this.manageOAuthError(e);
      return null;
    }
  }

  webOAuthLogout() {
    //return this.fireAuth.signOut();
  }

  getBusinessData(userId: string, accessToken: string) {
    let headers: HttpHeaders;

    if (accessToken) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      headers = new HttpHeaders({ Authorization: 'Bearer ' + accessToken });
    }

    return this.httpClient.get<any>(
      `${this.baseUrl}/${userId}/businesses?fields=profile_picture_uri,vertical,name,created_by`,
      { headers }
    );
  }

  getPagesList(userId: number | string, accessToken: string) {
    let headers: HttpHeaders;

    if (accessToken) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      headers = new HttpHeaders({ Authorization: 'Bearer ' + accessToken });
    }

    return this.httpClient.get<any>(`${this.baseUrl}/${userId}/accounts`, { headers });
  }

  getSelectedPagesList(userId: number | string, accessToken: string) {
    return this.httpClient.get<any>(`${this.baseUrl}/${userId}/accounts?access_token=${accessToken}`);
  }
}
